export enum ChatPageType
{
    ChannelListing,
    ChannelDetail
}